<template>
  <div class="card-guide">
    <b-button
        variant="success"
        @click="handleSendEmail"
    >
      Send Email
    </b-button>
    <div class="card-guide-body">
      <div class="d-flex justify-content-between">
        <span class="search">
          <label>
            <img :src="searchIconSVG" />
            <input
            <input
              type="search"
              class="search-input"
              placeholder="Search Users"
              v-model="searchStr"
            /> </label
        ></span>
        <spreadsheet
          class="download"
          :columns="columns"
          :content="content"
          file-name="Users"
          sheet-name="Users"
        />
      </div>
      <div class="users" role="tablist">
        <b-card no-body>
          <b-table
            id="table-transition"
            :items="users"
            :fields="filteredFields"
            :busy="isBusy"
            striped
            small
            primary-key="a"
            stacked="lg"
            :tbody-transition-props="transProps"
          >
            <template #table-busy>
              <b-skeleton-table
                :rows="skeletonRows"
                :columns="filteredFields.length"
                :table-props="{ bordered: true, striped: true }"
              />
            </template>
            <template #cell(index)="data">
              {{ data.index + 1 }}
            </template>
            <!-- A custom formatted column -->
            <template #cell(imgURL)="row">
              <b-avatar variant="info" :src="row.item.imgURL" class="mr-3">
              </b-avatar>
            </template>
            <template #cell(accounts)="row">
              <svg
                v-if="getAccounts(row.item).includes('A')"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22.5 9.72656L20.5781 9.30469C20.4375 8.85156 20.25 8.39062 20.0156 7.92188L21.0469 6.1875C21.1875 5.96875 21.293 5.73828 21.3633 5.49609C21.4336 5.25391 21.4453 5 21.3984 4.73438C21.3516 4.46875 21.2344 4.24219 21.0469 4.05469L19.9922 3C19.8516 2.85938 19.6836 2.75391 19.4883 2.68359C19.293 2.61328 19.0977 2.58203 18.9023 2.58984C18.707 2.59766 18.5156 2.63281 18.3281 2.69531C18.1406 2.75781 17.9688 2.83594 17.8125 2.92969L16.125 4.00781L15.9375 3.91406L15.75 3.82031L15.5625 3.73828L15.3633 3.65625L15.1641 3.57422L14.9648 3.50391L14.7656 3.44531L14.3438 1.47656C14.2656 1.10156 14.0781 0.761719 13.7812 0.457031C13.4844 0.152344 13.1406 0 12.75 0H11.25C10.8594 0 10.5352 0.148438 10.2773 0.445312C10.0195 0.742188 9.84375 1.09375 9.75 1.5L9.25781 3.42188C9.00781 3.5 8.76172 3.58984 8.51953 3.69141C8.27734 3.79297 8.03906 3.90625 7.80469 4.03125L6.07031 2.92969C5.86719 2.78906 5.63672 2.69141 5.37891 2.63672C5.12109 2.58203 4.85938 2.58203 4.59375 2.63672C4.32812 2.69141 4.10156 2.8125 3.91406 3L2.83594 4.05469C2.57031 4.39844 2.44922 4.75 2.47266 5.10938C2.49609 5.46875 2.61719 5.82812 2.83594 6.1875L3.9375 8.01562C3.71875 8.46875 3.54688 8.89844 3.42188 9.30469L1.5 9.72656C1.10938 9.80469 0.761719 9.98828 0.457031 10.2773C0.152344 10.5664 0 10.9141 0 11.3203V12.8203C0 13.1953 0.148438 13.5156 0.445312 13.7812C0.742188 14.0469 1.09375 14.2266 1.5 14.3203L3.44531 14.7891C3.57031 15.1797 3.73438 15.5781 3.9375 15.9844L2.83594 17.8125C2.61719 18.1719 2.49609 18.5312 2.47266 18.8906C2.44922 19.25 2.57031 19.6016 2.83594 19.9453L3.91406 21C4.22656 21.2812 4.58594 21.418 4.99219 21.4102C5.39844 21.4023 5.75781 21.2891 6.07031 21.0703L7.80469 19.9688L8.08594 20.1094L8.37891 20.2383L8.68359 20.3555L8.98828 20.4727L9.28125 20.5781L9.75 22.5C9.84375 22.9062 10.0234 23.2578 10.2891 23.5547C10.5547 23.8516 10.875 24 11.25 24H12.75C13.0156 24 13.2656 23.9258 13.5 23.7773C13.7344 23.6289 13.9219 23.4414 14.0625 23.2148C14.2031 22.9883 14.2969 22.75 14.3438 22.5L14.7656 20.5547C15.2344 20.4141 15.6875 20.2266 16.125 19.9922L17.8125 21.0703C18.1406 21.2891 18.5078 21.4023 18.9141 21.4102C19.3203 21.418 19.6797 21.2812 19.9922 21L21.0469 19.9453C21.3125 19.6016 21.4336 19.25 21.4102 18.8906C21.3867 18.5312 21.2656 18.1719 21.0469 17.8125L20.0156 16.0781C20.2344 15.6562 20.4141 15.2266 20.5547 14.7891L22.5 14.3203C22.9062 14.2266 23.2578 14.0469 23.5547 13.7812C23.8516 13.5156 24 13.1953 24 12.8203V11.3203C24 10.7109 23.6797 10.2422 23.0391 9.91406C22.8672 9.82031 22.6875 9.75781 22.5 9.72656ZM22.5 12.7031C22.4844 12.7188 22.4609 12.7344 22.4297 12.75C22.3984 12.7656 22.3594 12.7812 22.3125 12.7969L22.1719 12.8438L19.3828 13.5469L19.125 14.3203C19.0625 14.5078 18.9961 14.6914 18.9258 14.8711C18.8555 15.0508 18.7734 15.2266 18.6797 15.3984L18.3047 16.1484L19.7812 18.5859C19.8594 18.7266 19.9062 18.8516 19.9219 18.9609L18.9375 19.9453C18.875 19.9297 18.8203 19.9102 18.7734 19.8867C18.7266 19.8633 18.6953 19.8438 18.6797 19.8281L16.2188 18.2578L15.4453 18.6562C15.3203 18.7188 15.1953 18.7773 15.0703 18.832L14.6953 18.9961L14.3203 19.125L13.5 19.4062L12.8906 22.1953C12.875 22.2578 12.8516 22.3164 12.8203 22.3711C12.7891 22.4258 12.7578 22.4688 12.7266 22.5H11.3672C11.3047 22.4062 11.2578 22.2969 11.2266 22.1719L10.5234 19.4062L9.72656 19.1484C9.67969 19.1328 9.63672 19.1172 9.59766 19.1016C9.55859 19.0859 9.51562 19.0703 9.46875 19.0547L9.32812 19.0078L9.1875 18.9492L9.04688 18.8906L8.90625 18.832L8.77734 18.7734L8.64844 18.7148L8.50781 18.6328L7.73438 18.2344L5.27344 19.8047C5.16406 19.8828 5.0625 19.9219 4.96875 19.9219L3.98438 18.9609C4 18.8516 4.04688 18.7344 4.125 18.6094L5.64844 16.0547L5.29688 15.3281C5.125 14.9844 4.98438 14.6562 4.875 14.3438L4.61719 13.5469L1.875 12.8438C1.71875 12.8125 1.59375 12.7656 1.5 12.7031V11.3203C1.51562 11.3203 1.53516 11.3125 1.55859 11.2969C1.58203 11.2812 1.61328 11.2617 1.65234 11.2383C1.69141 11.2148 1.72656 11.2031 1.75781 11.2031L4.59375 10.5703L4.85156 9.75C4.94531 9.42188 5.08594 9.0625 5.27344 8.67188L5.64844 7.94531L4.125 5.41406C4.09375 5.35156 4.0625 5.28516 4.03125 5.21484C4 5.14453 3.98438 5.08594 3.98438 5.03906L4.96875 4.05469L5.22656 4.17188L7.73438 5.76562L8.50781 5.36719C8.89844 5.16406 9.30469 4.99219 9.72656 4.85156L10.5234 4.59375L11.2031 1.875C11.2344 1.71875 11.2891 1.59375 11.3672 1.5H12.75L12.7734 1.57031C12.7891 1.58594 12.8008 1.60156 12.8086 1.61719C12.8164 1.63281 12.8242 1.65625 12.832 1.6875C12.8398 1.71875 12.8516 1.74219 12.8672 1.75781L13.4766 4.59375L14.2969 4.875C14.6875 5 15.0703 5.15625 15.4453 5.34375L16.2188 5.74219L18.6328 4.19531C18.7422 4.13281 18.8438 4.10156 18.9375 4.10156L19.9219 5.0625C19.9062 5.09375 19.8906 5.14062 19.875 5.20312C19.8594 5.26562 19.8281 5.32812 19.7812 5.39062L18.3047 7.85156L18.6797 8.60156C18.7891 8.80469 18.8828 9 18.9609 9.1875C19.0391 9.375 19.1016 9.5625 19.1484 9.75L19.4062 10.5703L22.1953 11.2031C22.3672 11.2344 22.4766 11.2891 22.5234 11.3672L22.5 12.7031ZM12.0117 7.5C10.7695 7.5 9.70703 7.9375 8.82422 8.8125C7.94141 9.6875 7.5 10.75 7.5 12C7.5 13.25 7.94141 14.3125 8.82422 15.1875C9.70703 16.0625 10.7656 16.5 12 16.5C12.625 16.5 13.2148 16.3828 13.7695 16.1484C14.3242 15.9141 14.8047 15.5938 15.2109 15.1875C15.6172 14.7812 15.9375 14.3008 16.1719 13.7461C16.4062 13.1914 16.5234 12.6094 16.5234 12C16.5234 10.75 16.082 9.6875 15.1992 8.8125C14.3164 7.9375 13.2539 7.5 12.0117 7.5ZM12 15C11.1719 15 10.4648 14.707 9.87891 14.1211C9.29297 13.5352 9 12.8281 9 12C9 11.1719 9.29297 10.4648 9.87891 9.87891C10.4648 9.29297 11.1719 9 12 9C12.8281 9 13.5352 9.29297 14.1211 9.87891C14.707 10.4648 15 11.1719 15 12C15 12.8281 14.707 13.5352 14.1211 14.1211C13.5352 14.707 12.8281 15 12 15Z"
                  fill="var(--theme-color)"
                />
              </svg>
              <svg
                v-if="getAccounts(row.item).includes('B')"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.6975 6.87062C11.6975 6.87062 11.9747 6.54449 12.837 5.33553C13.6993 4.12657 16.6353 6.48665 15.8757 7.63816C15.116 8.78967 14.7362 9.26355 14.7362 9.26355M11.6975 6.87062L5.99994 14.5461C5.99994 14.5461 5.49994 17.5 5.99994 18C6.49994 18.5 9.41846 16.8487 9.41846 16.8487L14.7362 9.26355M11.6975 6.87062L14.7362 9.26355"
                  stroke="var(--theme-color)"
                  stroke-width="1.4"
                />
                <path
                  d="M6 18H21"
                  stroke="var(--theme-color)"
                  stroke-width="1.4"
                />
                <rect
                  x="2.7"
                  y="2.7"
                  width="18.6"
                  height="18.6"
                  rx="2.3"
                  stroke="var(--theme-color)"
                  stroke-width="1.4"
                />
              </svg>
              <svg
                v-if="getAccounts(row.item).includes('G')"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.0012 0.875977C9.48102 0.878636 7.0343 1.72532 5.05148 3.28092C3.06866 4.83653 1.66398 7.01142 1.06158 9.45858L2.55668 9.59066C3.11925 7.51576 4.34866 5.68351 6.05539 4.37632C7.76212 3.06913 9.85142 2.35958 12.0012 2.35706C12.6511 2.35724 13.2994 2.4221 13.9365 2.55066L14.4693 1.16381C13.6597 0.977257 12.832 0.880726 12.0012 0.875977ZM14.7819 1.23406L14.6438 2.73009C16.7007 3.30625 18.5129 4.53885 19.8045 6.24017C21.0962 7.9415 21.7964 10.0183 21.7986 12.1544C21.7981 12.8164 21.7306 13.4766 21.597 14.125L22.9775 14.6865C23.1736 13.8566 23.275 13.0071 23.2796 12.1544C23.2774 9.64884 22.441 7.21536 20.9022 5.23795C19.3635 3.26055 17.2101 1.85182 14.7819 1.23406ZM1.0175 9.65545C0.826316 10.4748 0.727419 11.313 0.722656 12.1544C0.725355 14.6755 1.57266 17.123 3.12929 19.1061C4.68591 21.0893 6.8621 22.4937 9.3104 23.0951L9.42566 21.596C7.35342 21.0314 5.52413 19.8015 4.21925 18.0956C2.91437 16.3896 2.20621 14.3022 2.20374 12.1544C2.20377 11.5014 2.2691 10.85 2.39874 10.2099L1.0175 9.65545ZM21.4374 14.7505C20.8692 16.818 19.6385 18.6421 17.934 19.9429C16.2295 21.2437 14.1454 21.9495 12.0012 21.9519C11.3601 21.9513 10.7207 21.8877 10.092 21.7622L9.55073 23.149C10.3547 23.333 11.1765 23.4282 12.0012 23.433C14.5155 23.4304 16.9569 22.5878 18.9375 21.039C20.9181 19.4902 22.3243 17.324 22.9329 14.8845L21.4374 14.7505Z"
                  fill="var(--theme-color)"
                />
                <path
                  d="M14.707 0L10.8176 10.1236L0.393779 9.20288L0.303711 9.58022L9.85803 13.4161L9.05095 23.9141L9.42888 24L13.2483 14.2143L23.5967 15.1409L23.6885 14.7642L14.0895 10.86L15.0849 0.0883024L14.707 0ZM14.564 1.46346L13.6727 11.1137L22.3269 14.6335L12.9904 13.7975L9.5425 22.6307L10.2707 13.1594L1.67828 9.70973L11.0772 10.5398L14.564 1.46346Z"
                  fill="var(--theme-color)"
                />
                <path
                  d="M8.0459 5.72461L8.14948 6.24047L8.97514 10.3541L11.0775 10.5398L11.8068 8.6416L8.0459 5.72461ZM8.63715 6.67908L11.3367 8.77275L10.8177 10.1236L9.3016 9.98966L8.63715 6.67908Z"
                  fill="var(--theme-color)"
                />
                <path
                  d="M18.4603 8.15576L17.9304 8.26214L13.8608 9.07924L13.6729 11.1136L15.4893 11.8523L18.4603 8.15576ZM17.478 8.75262L15.3665 11.3794L14.0897 10.86L14.2241 9.40601L17.478 8.75262Z"
                  fill="var(--theme-color)"
                />
                <path
                  d="M12.9905 13.7979L12.9369 13.9349L12.2217 15.7677L15.9992 18.637L15.2145 13.9971L12.9905 13.7979ZM13.2486 14.2143L14.8787 14.3603L15.4478 17.7262L12.6942 15.6347L13.2486 14.2143Z"
                  fill="var(--theme-color)"
                />
                <path
                  d="M8.57877 12.4805L8.4875 12.5895L5.45898 16.2085L10.1139 15.199L10.2707 13.1596L8.57877 12.4805ZM8.69683 12.9499L9.85799 13.4162L9.74569 14.8779L6.4932 15.5833L8.69683 12.9499Z"
                  fill="var(--theme-color)"
                />
              </svg>
              <svg
                v-if="getAccounts(row.item).includes('C')"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.0012 0.875977C9.48102 0.878636 7.0343 1.72532 5.05148 3.28092C3.06866 4.83653 1.66398 7.01142 1.06158 9.45858L2.55668 9.59066C3.11925 7.51576 4.34866 5.68351 6.05539 4.37632C7.76212 3.06913 9.85142 2.35958 12.0012 2.35706C12.6511 2.35724 13.2994 2.4221 13.9365 2.55066L14.4693 1.16381C13.6597 0.977257 12.832 0.880726 12.0012 0.875977ZM14.7819 1.23406L14.6438 2.73009C16.7007 3.30625 18.5129 4.53885 19.8045 6.24017C21.0962 7.9415 21.7964 10.0183 21.7986 12.1544C21.7981 12.8164 21.7306 13.4766 21.597 14.125L22.9775 14.6865C23.1736 13.8566 23.275 13.0071 23.2796 12.1544C23.2774 9.64884 22.441 7.21536 20.9022 5.23795C19.3635 3.26055 17.2101 1.85182 14.7819 1.23406ZM1.0175 9.65545C0.826316 10.4748 0.727419 11.313 0.722656 12.1544C0.725355 14.6755 1.57266 17.123 3.12929 19.1061C4.68591 21.0893 6.8621 22.4937 9.3104 23.0951L9.42566 21.596C7.35342 21.0314 5.52413 19.8015 4.21925 18.0956C2.91437 16.3896 2.20621 14.3022 2.20374 12.1544C2.20377 11.5014 2.2691 10.85 2.39874 10.2099L1.0175 9.65545ZM21.4374 14.7505C20.8692 16.818 19.6385 18.6421 17.934 19.9429C16.2295 21.2437 14.1454 21.9495 12.0012 21.9519C11.3601 21.9513 10.7207 21.8877 10.092 21.7622L9.55073 23.149C10.3547 23.333 11.1765 23.4282 12.0012 23.433C14.5155 23.4304 16.9569 22.5878 18.9375 21.039C20.9181 19.4902 22.3243 17.324 22.9329 14.8845L21.4374 14.7505Z"
                  fill="var(--theme-color)"
                />
                <path
                  d="M14.707 0L10.8176 10.1236L0.393779 9.20288L0.303711 9.58022L9.85803 13.4161L9.05095 23.9141L9.42888 24L13.2483 14.2143L23.5967 15.1409L23.6885 14.7642L14.0895 10.86L15.0849 0.0883024L14.707 0ZM14.564 1.46346L13.6727 11.1137L22.3269 14.6335L12.9904 13.7975L9.5425 22.6307L10.2707 13.1594L1.67828 9.70973L11.0772 10.5398L14.564 1.46346Z"
                  fill="var(--theme-color)"
                />
                <path
                  d="M8.0459 5.72461L8.14948 6.24047L8.97514 10.3541L11.0775 10.5398L11.8068 8.6416L8.0459 5.72461ZM8.63715 6.67908L11.3367 8.77275L10.8177 10.1236L9.3016 9.98966L8.63715 6.67908Z"
                  fill="var(--theme-color)"
                />
                <path
                  d="M18.4603 8.15576L17.9304 8.26214L13.8608 9.07924L13.6729 11.1136L15.4893 11.8523L18.4603 8.15576ZM17.478 8.75262L15.3665 11.3794L14.0897 10.86L14.2241 9.40601L17.478 8.75262Z"
                  fill="var(--theme-color)"
                />
                <path
                  d="M12.9905 13.7979L12.9369 13.9349L12.2217 15.7677L15.9992 18.637L15.2145 13.9971L12.9905 13.7979ZM13.2486 14.2143L14.8787 14.3603L15.4478 17.7262L12.6942 15.6347L13.2486 14.2143Z"
                  fill="var(--theme-color)"
                />
                <path
                  d="M8.57877 12.4805L8.4875 12.5895L5.45898 16.2085L10.1139 15.199L10.2707 13.1596L8.57877 12.4805ZM8.69683 12.9499L9.85799 13.4162L9.74569 14.8779L6.4932 15.5833L8.69683 12.9499Z"
                  fill="var(--theme-color)"
                />
              </svg>
            </template>
            <template #cell(auth)="row">
              <svg
                v-if="row.item._provider == 'goog'"
                width="29"
                height="29"
                viewBox="0 0 256 262"
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="xMidYMid"
              >
                <path
                  d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027"
                  fill="#4285F4"
                />
                <path
                  d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1"
                  fill="#34A853"
                />
                <path
                  d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782"
                  fill="#FBBC05"
                />
                <path
                  d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251"
                  fill="#EB4335"
                />
              </svg>
              <svg
                v-if="row.item._provider == 'fb'"
                class="ml-1 mt-1"
                width="31"
                height="32"
                viewBox="0 0 29 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0)">
                  <path
                    d="M26.6663 28.0001C27.5265 28.0001 28.224 27.3082 28.224 26.4548V1.54536C28.224 0.691797 27.5265 0 26.6663 0H1.55772C0.697221 0 0 0.691797 0 1.54536V26.4548C0 27.3082 0.697221 28.0001 1.55772 28.0001H26.6663Z"
                    fill="#395185"
                  />
                  <path
                    d="M19.474 28.0001V17.157H23.1428L23.6921 12.9313H19.474V10.2332C19.474 9.00977 19.8166 8.176 21.5851 8.176L23.8407 8.17502V4.39557C23.4504 4.34405 22.1115 4.22899 20.5539 4.22899C17.3017 4.22899 15.0754 6.19828 15.0754 9.81488V12.9313H11.3972V17.157H15.0754V28.0001H19.474Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="28.224" height="28" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <svg
                v-if="row.item._provider == 'email'"
                xmlns="http://www.w3.org/2000/svg"
                width="29"
                height="29"
                viewBox="1 1 600 600"
              >
                <g transform="matrix(6.66667 0 0 6.66667 -5.667 -6408.081)">
                  <linearGradient
                    id="a"
                    gradientUnits="userSpaceOnUse"
                    x1="-110.934"
                    y1="1129.751"
                    x2="-110.35"
                    y2="1720.099"
                    gradientTransform="matrix(1 0 0 -1 156.89 2180.75)"
                  >
                    <stop offset="0" stop-color="#70efff" />
                    <stop offset="1" stop-color="#5770ff" />
                  </linearGradient>
                  <path
                    d="M21.653 961.362h48.695a20.608 20.608 0 0 1 20.653 20.653v48.695a20.608 20.608 0 0 1-20.653 20.653H21.653A20.608 20.608 0 0 1 1 1030.71v-48.695a20.608 20.608 0 0 1 20.653-20.653z"
                    fill="url(#a)"
                  />
                  <path
                    d="M20.719 986.956c-.474 0-.921.082-1.344.25l8.469 8.719 8.563 8.875.156.188.25.25.25.25.5.531 7.344 7.531c.122.076.477.404.754.543.357.178.743.343 1.141.357.43.015.869-.108 1.256-.296.29-.141.419-.343.755-.603l8.5-8.781 8.594-8.844 8.281-8.531a3.635 3.635 0 0 0-1.75-.438H20.719zm-2.594 1.062c-.903.856-1.469 2.142-1.469 3.594v28.625c0 1.175.377 2.243 1 3.062l1.187-1.125 8.844-8.594 7.844-7.594-.156-.187-8.594-8.844-8.594-8.875-.062-.062zm57.188.282l-8.375 8.656-8.563 8.844-.156.156 8.156 7.906 8.844 8.594.531.5c.476-.764.75-1.705.75-2.719v-28.625c0-1.294-.448-2.468-1.187-3.312zm-38.782 18.718l-7.812 7.594-8.875 8.594-1.125 1.094c.593.382 1.268.625 2 .625h51.719c.88 0 1.678-.338 2.344-.875l-.562-.562-8.875-8.594-8.156-7.875-7.344 7.562c-.397.264-.663.556-1.051.735-.625.289-1.309.533-1.997.523-.69-.011-1.367-.281-1.986-.585-.311-.153-.477-.305-.841-.61l-7.439-7.626z"
                    fill="#fff"
                  />
                </g>
              </svg>
            </template>
            <template #cell(actions)="row">
              <div class="actions">
                <b-link
                  size="sm"
                  @click="editUserAccounts(row.item)"
                  class="mt-2"
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M2.66667 3.33333C2.48986 3.33333 2.32029 3.40357 2.19527 3.5286C2.07024 3.65362 2.00001 3.82319 2.00001 4V13.3333C2.00001 13.5101 2.07024 13.6797 2.19527 13.8047C2.32029 13.9298 2.48986 14 2.66667 14H12C12.1768 14 12.3464 13.9298 12.4714 13.8047C12.5964 13.6797 12.6667 13.5101 12.6667 13.3333V9.77333C12.6667 9.40514 12.9651 9.10667 13.3333 9.10667C13.7015 9.10667 14 9.40514 14 9.77333V13.3333C14 13.8638 13.7893 14.3725 13.4142 14.7475C13.0391 15.1226 12.5304 15.3333 12 15.3333H2.66667C2.13624 15.3333 1.62753 15.1226 1.25246 14.7475C0.877385 14.3725 0.666672 13.8638 0.666672 13.3333V4C0.666672 3.46957 0.877385 2.96086 1.25246 2.58579C1.62753 2.21071 2.13624 2 2.66667 2H6.22667C6.59486 2 6.89334 2.29848 6.89334 2.66667C6.89334 3.03486 6.59486 3.33333 6.22667 3.33333H2.66667Z"
                      fill="#B3C2CB"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M11.5286 0.862254C11.7889 0.601905 12.2111 0.601905 12.4714 0.862254L15.1381 3.52892C15.3984 3.78927 15.3984 4.21138 15.1381 4.47173L8.47141 11.1384C8.34639 11.2634 8.17682 11.3337 8 11.3337H5.33334C4.96515 11.3337 4.66667 11.0352 4.66667 10.667V8.00033C4.66667 7.82351 4.73691 7.65394 4.86193 7.52892L11.5286 0.862254ZM6.00001 8.27647V10.0003H7.72386L13.7239 4.00033L12 2.27647L6.00001 8.27647Z"
                      fill="#B3C2CB"
                    />
                  </svg>
                </b-link>
                <b-link
                  size="sm"
                  @click="
                    handleUserNotifyClick(row.item, row.index, $event.target)
                  "
                  class="ml-1 mt-2"
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 20C9.6193 20.0008 10.2235 19.8086 10.7285 19.4502C11.2335 19.0917 11.6143 18.5849 11.818 18H6.182C6.38566 18.5849 6.76648 19.0917 7.27151 19.4502C7.77654 19.8086 8.3807 20.0008 9 20ZM16 12.586V8C16 4.783 13.815 2.073 10.855 1.258C10.562 0.52 9.846 0 9 0C8.154 0 7.438 0.52 7.145 1.258C4.185 2.074 2 4.783 2 8V12.586L0.293001 14.293C0.199958 14.3857 0.126171 14.4959 0.0758854 14.6172C0.0256001 14.7386 -0.000189449 14.8687 1.04767e-06 15V16C1.04767e-06 16.2652 0.105358 16.5196 0.292894 16.7071C0.480431 16.8946 0.734785 17 1 17H17C17.2652 17 17.5196 16.8946 17.7071 16.7071C17.8946 16.5196 18 16.2652 18 16V15C18.0002 14.8687 17.9744 14.7386 17.9241 14.6172C17.8738 14.4959 17.8 14.3857 17.707 14.293L16 12.586Z"
                      fill="#B3C2CB"
                    />
                  </svg>
                </b-link>
                <b-btn
                  v-if="row.item._beta"
                  variant="outline-primary"
                  class="ml-1 mt-2"
                  size="sm"
                  disabled="disabled"
                >
                  Approved
                </b-btn>
                <b-btn
                  v-else
                  variant="outline-primary"
                  @click="approveUser(row.item, row.item.userRef)"
                  :id="row.item.userRef"
                  class="ml-1 mt-2"
                  size="sm"
                >
                  {{ btnText }}
                </b-btn>
              </div>
            </template>
            <template #cell(show_details)="row">
              <b-icon
                v-if="row.detailsShowing"
                @click="row.toggleDetails"
                icon="chevron-compact-up"
                font-scale="2"
              >
              </b-icon>
              <b-icon
                v-else
                @click="row.toggleDetails"
                icon="chevron-compact-down"
                font-scale="2"
              >
              </b-icon>
            </template>
            <template #row-details="row">
              <b-card>
                <b-row class="mb-2">
                  <b-col sm="3" class="text-sm-right"><b>UserId:</b></b-col>
                  <b-col v-if="row.item.userRef">{{ row.item.userRef }}</b-col>
                  <b-col v-else>No Id Found</b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col sm="3" class="text-sm-right"><b>MainLine:</b></b-col>
                  <b-col v-if="row.item.mainline">{{
                    row.item.mainline
                  }}</b-col>
                  <b-col v-else>No MainLine Specified</b-col>
                </b-row>

                <b-row class="mb-2">
                  <b-col sm="3" class="text-sm-right"><b>Language:</b></b-col>
                  <b-col v-if="row.item.abouts && row.item.abouts.language">{{
                    row.item.abouts.language
                  }}</b-col>
                  <b-col v-else>No language Specified</b-col>
                </b-row>

                <b-row class="mb-2">
                  <b-col sm="3" class="text-sm-right"><b>Phone #:</b></b-col>
                  <b-col v-if="row.item.phoneNumber">{{
                    row.item.phoneNumber
                  }}</b-col>
                  <b-col v-else>No Phone Number Specified</b-col>
                </b-row>
              </b-card>
            </template>
          </b-table>
        </b-card>
        <b-pagination
          v-model="currentPage"
          :total-rows="allUsers.length"
          :per-page="perPage"
          align="left"
          size="sm"
          class="my-0"
        ></b-pagination>
      </div>
      <modal :id="userModal">
        <div class="add-user" v-if="!del">
          <span class="close-icon" @click="$bvModal.hide(userModal)">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
              <g clip-path="url(#clip0)">
                <path
                  d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                  fill="#606770"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="10.6667"
                    height="10.6667"
                    fill="white"
                    transform="translate(6.6665 6.66675)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <h3>{{ add ? "Add" : "Edit" }} User</h3>
          <div class="h-18"></div>
          <b-form-group>
            <b-form-input
              type="text"
              required
              v-model="formFullName"
              placeholder="Full Name"
            ></b-form-input>
            <b-form-input
              type="text"
              required
              v-model="formEmail"
              placeholder="Email"
            ></b-form-input>
          </b-form-group>
          <b-form-group class="textarea-scroll">
            <b-form-textarea
              id="textarea-default"
              rows="8"
              no-resize
              v-model="formPhone"
              placeholder="Enter your answer here"
            ></b-form-textarea>
          </b-form-group>

          <div class="d-flex justify-content-between">
            <b-button
              variant="light btn-simple"
              @click="$bvModal.hide(userModal)"
            >
              Cancel
            </b-button>
            <b-button
              variant="primary btn-round-fill "
              v-if="add"
              @click="addUser"
              :disabled="
                formFullName.trim().length > 0 && formEmail.trim().length > 0
                  ? false
                  : true
              "
            >
              Add
            </b-button>
            <b-button
              variant="primary btn-round-fill"
              @click="editUser"
              v-else
              :disabled="
                formFullName.trim().length > 0 && formEmail.trim().length > 0
                  ? false
                  : true
              "
            >
              Update
            </b-button>
          </div>
        </div>
        <div class="add-user del-user" v-else>
          <span class="close-icon" @click="$bvModal.hide(userModal)">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
              <g clip-path="url(#clip0)">
                <path
                  d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                  fill="#606770"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="10.6667"
                    height="10.6667"
                    fill="white"
                    transform="translate(6.6665 6.66675)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <h3>Delete FAQ</h3>
          <div class="warning-msg">
            <p>
              Are you sure want to delete
              <strong>
                {{ users[activeIndex].q }}
              </strong>
              User?
            </p>
          </div>
          <div class="d-flex justify-content-between">
            <b-button variant="danger btn-round-fill" @click="deleteUser">
              Yes! Delete
            </b-button>
            <b-button variant="light btn-simple" @click="hideDeleteUser">
              No! back
            </b-button>
          </div>
        </div>
      </modal>
      <modal :id="editUserModal">
        <div class="add-user">
          <span class="close-icon" @click="$bvModal.hide(editUserModal)">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
              <g clip-path="url(#clip0)">
                <path
                  d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                  fill="#606770"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="10.6667"
                    height="10.6667"
                    fill="white"
                    transform="translate(6.6665 6.66675)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <h3>Edit User</h3>
          <div label="Info">
            <b-avatar variant="info" :src="selectedUser.imgURL" class="mr-3">
            </b-avatar>
            <div>
              <div>
                {{ selectedUser.firstname }} {{ selectedUser.lastname }}
              </div>
              <div>
                {{ selectedUser.email }}
              </div>
            </div>
          </div>
          <div class="h-18"></div>
          <b-form-group label="MainLine">
            <b-form-input
              type="text"
              required
              v-model="userMainLine"
              placeholder="Enter user's main line here"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Company">
            {{
              isCompanyAdmin(selectedUser) ? " IS COMPANY" : "Make CompanyAdmin"
            }}
            <b-button
              :disabled="isCompanyAdmin(selectedUser)"
              size="sm"
              @click="makeUserCompanyAdmin(selectedUser)"
              class="mr-1"
              variant="primary btn-round-fill"
            >
              Make Company Admin - List company names
            </b-button>
          </b-form-group>
          <b-form-group label="Admin">
            {{ isAdmin(selectedUser) ? " IS ADMIN" : "Make Admin" }}
            <b-button
              :disabled="isAdmin(selectedUser)"
              size="sm"
              @click="makeUserAdmin(selectedUser)"
              class="mr-1"
              variant="primary btn-round-fill"
            >
              Make Admin
            </b-button>
          </b-form-group>
          <b-form-group label="Publisher Platform">
            {{ isGuide(selectedUser) ? " IS Publisher" : "Make Publisher" }}
            <b-button
              :disabled="isGuide(selectedUser)"
              size="sm"
              @click="makeUserGuide(selectedUser)"
              class="mr-1"
              variant="primary btn-round-fill"
            >
              Publisher
            </b-button>
          </b-form-group>
          <b-form-group label="Blog">
            {{ isBlogger(selectedUser) ? " IS BLOGGER" : "Make BLOGGER" }}
            <b-button
              :disabled="isBlogger(selectedUser)"
              size="sm"
              @click="makeUserBlogger(selectedUser)"
              class="mr-1"
              variant="primary btn-round-fill"
            >
              Blogger
            </b-button>
          </b-form-group>

          <div class="d-flex justify-content-between">
            <b-button
              variant="light btn-simple"
              @click="$bvModal.hide(editUserModal)"
            >
              Cancel
            </b-button>
            <b-button
              variant="primary btn-round-fill"
              v-if="add"
              @click="saveEditingUser"
            >
              Update
            </b-button>
          </div>
        </div>
      </modal>
      <modal :id="notifymodal">
        <div class="add-user">
          <span class="close-icon" @click="$bvModal.hide(notifymodal)">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
              <g clip-path="url(#clip0)">
                <path
                  d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                  fill="#606770"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="10.6667"
                    height="10.6667"
                    fill="white"
                    transform="translate(6.6665 6.66675)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <h3>
            Notifications for {{ selectedUser ? selectedUser.firstname : "" }}
          </h3>
          <user-notify :data="selectedUser" />
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import Modal from "@/components/common/modal";
import userNotify from "../userNotify";
import Spreadsheet from "@/components/common/spreadsheet";
import firebase from "firebase";
//import admin from "firebase-admin";

export default {
  name: "AdminTabUsers",
  components: {
    Modal,
    userNotify,
    Spreadsheet
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      searchIconSVG: require("@/assets/svg/search-icon.svg"),
      skeletonRows: 5,
      fetchedUsers: false,
      editUserModal: "edit-user-modal",
      userModal: "member-modal",
      notifymodal: "member-notify-modal",
      searchStr: "",
      userMainLine: "",
      add: true,
      del: false,
      input: "",
      activeIndex: -1,
      formFullName: "",
      formEmail: "",
      formPhone: "",
      btnText: "Approve",
      btnStatus: "",
      transProps: {
        name: "flip-list" // Transition name
      },
      fields: [
        { key: "Index", sortable: false, label: "Ind", isAvail: true },
        { key: "imgURL", sortable: false, label: "Photo", isAvail: true },
        { key: "firstname", sortable: true, label: "First", isAvail: true },
        { key: "lastname", sortable: true, label: "Last", isAvail: true },
        { key: "email", sortable: true, label: "Email", isAvail: true },
        { key: "accounts", sortable: false, label: "Accounts", isAvail: true },
        {
          key: "_created_at",
          label: "Joined",
          sortable: true,
          formatter: "formatDate",
          isAvail: true
        },
        {
          key: "_signedin_at",
          label: "Last Sign In",
          sortable: true,
          formatter: "formatDate",
          isAvail: true
        },
        { key: "auth", label: "Auth", sortable: true, isAvail: true },
        { key: "actions", label: "Actions", isAvail: true },
        { key: "show_details", label: "Show Details", isAvail: true },
        { key: "id", label: "Id", isAvail: false },
        { key: "mainline", label: "Main Line", isAvail: false },
        { key: "phoneNumber", label: "Phone Number", isAvail: false },
        { key: "provider", label: "Provider", isAvail: false },
        { key: "_updated_at", label: "Show Details", isAvail: false }
      ],
      columns2: [
        { value: "imgURL", label: "Image" },
        { value: "firstname", label: "First" },
        { value: "lastname", label: "Last" },
        { value: "email", label: "Email" },
        { value: "_created_at", label: "Joined", formatter: "formatDate" },
        {
          value: "_signedin_at",
          label: "Last Sign In",
          formatter: "formatDate"
        },
        { value: "auth", label: "Auth" },
        { value: "actions", label: "Actions" },
        { value: "show_details", label: "Show Details" }
      ],
      currentPage: 1,
      perPage: 50,
      pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
      selectedUser: {},
      showUserNotify: false
    };
  },
  computed: {
    ...mapGetters({
      allUsers: "admin/users",
      allGuides: "listings/listGuides",
      allBloggers: "listings/listBloggers"
    }),
    isBusy() {
      return !this.allUsers || !this.fetchedUsers;
    },
    users() {
      if (this.searchStr.trim() == "") return this.allUsers;

      return this.allUsers.filter(user => {
        return (
          user.firstname
            .toLowerCase()
            .includes(this.searchStr.toLowerCase().trim()) ||
          user.lastname
            .toLowerCase()
            .includes(this.searchStr.toLowerCase().trim())
        );
      });
    },
    filteredFields() {
      return this.fields.filter(aField => {
        return aField.isAvail;
      });
    },
    columns() {
      return this.convertFieldToColumn(this.fields);
    },
    content() {
      return this.convertItemsToContent(this.users);
    }
  },
  mounted() {
    this.handleRefreshData();
  },
  methods: {
    handleSendEmail(){
      debugger;

      let payloadWelcome= {
        email_to:'savalas@heartbeatfam.com',
        email_from:'hi@heartbeatfam.com',
        subject:'Welcome to HeartBeatFam',
        template_id:'pq3enl689jr42vwr'
      };


      this.$store
          .dispatch("admin/sendEmail")
          .then(resp => {
            console.log(resp);

            this.$store.dispatch("user/showNotification", {
              title: `Email Sent`,
              description: `You've sent an email`,
              variant: "success"
            });

          }).catch(err =>{
        this.$store.dispatch("user/showNotification", {
          title: `Email Not Sent`,
          description: `You've sent an email to ${payloadWelcome.email_to}`,
          variant: "danger"
        });
        console.error(error);
      })
          .finally(data => {
            this.fetchedUsers = true;
          });

    },
    handleActivation() {
      this.handleRefreshData();
    },
    handleRefreshData() {
      this.fetchedUsers = false;
      this.$store
        .dispatch("admin/getUsers")
        .then(resp => {
          this.fetchedUsers = true;
        })
        .finally(data => {
          this.fetchedUsers = true;
        });
    },
    convertFieldToColumn(fields) {
      const columns = JSON.parse(JSON.stringify(fields));

      columns.forEach(aColumn => {
        if (aColumn.hasOwnProperty("key")) {
          aColumn.value = aColumn.key;
          delete aColumn["key"];
        }
        if (aColumn.hasOwnProperty("sortable")) {
          delete aColumn["sortable"];
        }
        if (aColumn.hasOwnProperty("formatter")) {
          delete aColumn["formatter"];
        }
      });

      return columns;
    },
    convertItemsToContent() {
      const content = [];
      if (this.users && Array.isArray(this.users)) {
        let index = 1;
        this.users.forEach(anItem => {
          const thisContent = {
            Index: index++,
            imgURL: `=IMAGE("${anItem.imgURL}")`,
            firstname: anItem.firstname,
            lastname: anItem.lastname,
            email: anItem.email,
            accounts: "",
            auth: "liberty",
            actions: "",
            show_details: "",
            _created_at: this.formatDate(anItem._created_at),
            _signedin_at: this.formatDate(anItem._signedin_at)
          };
          content.push(thisContent);
        });
      }
      return content;
    },
    isCompanyAdmin(user) {
      if (
        user &&
        user._dashboards &&
        user._dashboards.company &&
        user._dashboards.company._account
      ) {
        return user._dashboards.company._account.status === "active";
      } else {
        return false;
      }
    },
    isAdmin(user) {
      if (
        user &&
        user._dashboards &&
        user._dashboards.admin &&
        user._dashboards.admin._account
      ) {
        return user._dashboards.admin._account.status === "active";
      } else {
        return false;
      }
    },
    isGuide(user) {
      if (
        user &&
        user._dashboards &&
        user._dashboards.guide &&
        user._dashboards.guide._account
      ) {
        return user._dashboards.guide._account.status === "active";
      } else {
        return false;
      }
    },
    isBlogger(user) {
      if (
        user &&
        user._dashboards &&
        user._dashboards.blogger &&
        user._dashboards.blogger._account
      ) {
        return user._dashboards.blogger._account.status === "active";
      } else {
        return false;
      }
    },
    editUserAccounts(user) {
      this.selectedUser = user;
      this.$bvModal.show(this.editUserModal);
    },
    saveEditingUser() {
      this.$bvModal.hide(this.editUserModal);
    },
    makeUserCompanyAdmin(user) {
      let payLoad = {
        uid: user.userRef,
        type: "blog",
        status: "active"
      };

      this.$store
        .dispatch("admin/updateCompanyAdminDashboard", payLoad)
        .then(() => {
          this.$store.dispatch("admin/getUsers"); //@TODO- Should upload and not refresh table
          this.$store.dispatch("user/showNotification", {
            title: `${user.firstname} is now a CompanyAdmin`,
            description: `You have given Company Admin permission ${user.firstname}`,
            variant: "success"
          });
        })
        .catch(error => {
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        });
    },
    makeUserAdmin(user) {
      let payLoad = {
        uid: user.userRef,
        type: "blog",
        status: "active"
      };

      this.$store
        .dispatch("admin/updateAdminDashboard", payLoad)
        .then(() => {
          this.$store.dispatch("admin/getUsers"); //@TODO- Should upload and not refresh table
          this.$store.dispatch("user/showNotification", {
            title: `${user.firstname} is now an Admin`,
            description: `You have given Admin permission ${user.firstname}`,
            variant: "success"
          });
        })
        .catch(error => {
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        });
    },
    makeUserGuide(user) {
      this.$store
        .dispatch("admin/makeUserGuide", user.userRef)
        .then(() => {
          this.$store
            .dispatch("admin/updateGuideDashboard", user.userRef)
            .then(() => {
              this.$store.dispatch("admin/getUsers");
              this.$store.dispatch("user/showNotification", {
                title: `${user.firstname} is now a Guide`,
                description: `You have given the Guide subscription to ${user.firstname}`,
                variant: "success"
              });
            });
        })
        .catch(error => {
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        });
    },
    makeUserBlogger(user) {
      this.$store
        .dispatch("admin/makeUserBlogger", user.userRef)
        .then(() => {
          this.$store
            .dispatch("admin/updateBloggerDashboard", user.userRef)
            .then(() => {
              this.$store.dispatch("admin/getUsers");
              this.$store.dispatch("user/showNotification", {
                title: `${user.firstname} is now a Blogger`,
                description: `You have given the Blogger subscription to ${user.firstname}`,
                variant: "success"
              });
            });
        })
        .catch(error => {
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        });
    },
    handleAddUser() {
      this.del = false;
      this.add = true;
      this.formFullName = "";
      this.formEmail = "";
      this.$bvModal.show(this.userModal);
    },
    handleDownloadUsers() {
      this.del = false;
      this.add = true;
      this.formFullName = "";
      this.formEmail = "";
      this.$bvModal.show(this.userModal);
    },
    showEditUser(i) {
      this.del = false;
      this.add = false;
      this.activeIndex = i;
      this.formFullName = this.users[i].q;
      this.formEmail = this.users[i].a;
      this.$bvModal.show(this.userModal);
    },
    showDeleteUser(i) {
      this.del = true;
      this.activeIndex = i;
      this.$bvModal.show(this.userModal);
    },
    addUser() {
      this.users.push({
        q: this.formFullName,
        a: this.formEmail,
        _created_at: new Date()
      });
      this.$bvModal.hide(this.userModal);
      this.formFullName = "";
      this.formEmail = "";
      this.saveChanges();
    },
    editUser() {
      this.users[this.activeIndex].q = this.formFullName;
      this.users[this.activeIndex].a = this.formEmail;
      this.$bvModal.hide(this.userModal);
      this.input = "";
      this.saveChanges();
    },
    deleteUser() {
      this.users.splice(this.activeIndex, 1);
      this.$bvModal.hide(this.userModal);
      this.saveChanges();
    },
    hideDeleteUser() {
      this.$bvModal.hide(this.userModal);
    },
    getNested({ obj, def }, ...args) {
      let truthy = args.reduce((obj, level) => obj && obj[level], obj);
      if (truthy) {
        let val = Array.isArray(truthy) ? truthy : def;
        return val;
      } else {
        return def;
      }
    },
    saveChanges() {
      let dataToUpdateTags = {
        blogger: {
          users: this.users
        }
      };

      if (dataToUpdateTags) {
        this.$store
          .dispatch("user/updateProfileDashboardBlogger", dataToUpdateTags)
          .then(res => {
            if (res) {
              this.$store.dispatch("user/getProfile").then(() => {
                this.$store.dispatch("user/showNotification", {
                  title: "FAQs Updated Successfully",
                  description:
                    "Users will not see this info until you Publish.",
                  variant: "success"
                });
              });
            }
          });
      }
    },
    getAccounts(item) {
      if (!item._dashboards) return "";
      let dashboards = item._dashboards.admin ? "A" : "";
      dashboards += item._dashboards.blogger ? " B" : "";
      dashboards += item._dashboards.guide ? " G" : "";
      dashboards += item._dashboards.company ? " C" : "";
      return dashboards;
    },
    formatDate(date) {
      return date
        ? moment(date.toDate()).format("MMMM DD, YYYY h:MM a")
        : "N/A";
    },
    handleUserNotifyClick(user, index, event) {
      this.selectedUser = user;
      this.$bvModal.show(this.notifymodal);
    },
    approveUser(user, ref) {
      let btn = document.getElementById(ref);
      btn.setAttribute("disabled", "true");
      this.btnText = "Approved";
      this.$store
        .dispatch("admin/approveUser", user.userRef)
        .then(() => {
          // this.$store.getters["admin/users"];
          this.$store.dispatch("user/showNotification", {
            title: `${user.firstname} is approved now`,
            description: `You have approved user ${user.firstname}`,
            variant: "success"
          });
        })
        // })
        .catch(error => {
          console.log(error);
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.search {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: var(--theme-color);
  cursor: pointer;
  position: relative;
}

.download {
  cursor: pointer;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
}

.del-user {
  .warning-msg {
    margin: 24px 0;
    p {
      text-align: center;
      margin: 0;
    }
  }
  .btn-round-fill {
    background-color: #ef5c4a;
    border-color: #ef5c4a;
  }
  .btn-simple {
    color: #ef5c4a;
    font-weight: bold;
  }
}

.card-guide {
  box-shadow: none;
}
.users {
  margin-top: 20px;
  .card {
    border: none;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    .card-text {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      display: flex;
      align-items: center;
      color: #474d52;
    }
  }

  .card-header {
    display: grid;
    grid-template-columns: 1fr 30px;
    align-items: center;
    padding: 0;
    .edit,
    .delete {
      display: none;
      cursor: pointer;
    }
    .btn-collapse {
      padding: 24px;
      text-align: left;
      box-shadow: none;
    }
    &.active {
      grid-template-columns: 1fr 30px 30px 30px;
      .edit,
      .delete {
        display: block;
      }
      .btn-collapse {
        padding-bottom: 0px;
      }
    }

    border: none;
    box-shadow: none;
    background: none;
  }
}
.actions {
  display: flex;
  justify-content: space-evenly;
}
</style>
